import { useEffect } from 'react';

declare global {
  interface Window {
    SiennaPlugin?: {
      changeLanguage: (lang: string) => void;
    };
  }
}

export function AccessibilityWidget() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://website-widgets.pages.dev/dist/sienna.min.js';
    script.async = true;
    
    const handleScriptLoad = () => {
      const interval = setInterval(() => {
        if (window.SiennaPlugin && typeof window.SiennaPlugin.changeLanguage === 'function') {
          window.SiennaPlugin.changeLanguage('pt');
          clearInterval(interval);
        }
      }, 100);

      script.addEventListener('load', () => {
        clearInterval(interval);
      });
    };

    script.addEventListener('load', handleScriptLoad);
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
      script.removeEventListener('load', handleScriptLoad);
    };
  }, []);

  return null;
}
